import React, { useEffect, useState } from 'react';
import _get from 'lodash.get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Cookie from 'utils/cookies';
import {
  getGeoCountry,
  getPrcCookieValue,
  checkGracePeriod,
  getPreExpiryFormattedTime,
  getGraceFormattedTime,
  fetchUserSubscriptionStatusFromApi,
  checkPreExpireDate,
  checkIfOneDayRemaining,
  checkNewUser,
  setPayloadInfo,
  // getUserAccessPayload,
  getEncTicket,
} from 'utils/primeUtil';
// import {
//   loadPaymentSdk,
//   handlePlanClick,
// } from 'components/ToiSubscription/utils/payment';
// import makeRequest from 'utils/makeRequest';
// import { loadNudgeData } from 'reduxUtils/modules/translationConfig';
import {
  newPlanpageMetaData,
  redirectToNewPlanpage,
} from 'components/ToiSubscription/utils/redirectionToPlanPage';
import s from './TOIPlusWidgetMobile.scss';
import { gaWrapper } from '../../../../../helpers/analytics';
import Card from '../../../../../components_v2/common/CardV2';
// import Offers from '../../../../../components_v2/common/ToipOffers/Offers';
import ElementInView from '../../../../../components_v2/common/ElementInView/ElementInView';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import { fireCustomDimension } from '../../../../../utils/common';
import {
  WAP_INLINE_TOIPLUS_GA_CAT,
  //TOI_SUBS_FETCH_PLANS_MWEB,
  // YEAR_IN_DAYS,
  //   PAID,
  //   TOI_PLUS,
  // PRC_FOR_SUBSCRIBED,
} from '../../../../../constants';

function TOIPlusWidgetMobile({
  item,
  translationData,
  isUserPrime,
  geoCurrentCountry,
  // loadTOIPlusNudgeData,
  //homePageOffers,
  userData,
  userPrcData,
}) {
  const prcStatus = getPrcCookieValue();
  const [widgetLabels, setWidgetLabels] = useState(null);
  const [isSaleLive, setisSaleLive] = useState(false);
  const [graceDate, setGraceDate] = useState();
  const [daysRemaining, setDaysRemaining] = useState();
  const [inGracePeriod, setInGracePeriod] = useState(false);
  const [msid, setMsid] = useState([]);
  const [ispreExpired, setIsPreExpired] = useState(false);
  //const [subscriptionRes, setSubscription] = useState(null);
  const [userType, setUserType] = useState(null);

  useEffect(
    () => {
      if (translationData.TOIHPWidget) {
        setWidgetLabels(translationData.TOIHPWidget[prcStatus]);
      }
    },
    [translationData.TOIHPWidget],
  );

  useEffect(
    () => {
      if (translationData.PPSPriceWidget && userPrcData) {
        fetchUserSubscriptionStatusFromApi(userPrcData).then(data => {
          if (data?.data?.otps) {
            setMsid(data.data.otps.split(','));
          }
        });
      }
    },
    [translationData.PPSPriceWidget, userPrcData],
  );

  // useEffect(() => {
  //   loadPaymentSdk();

  //   const planUrl = `${TOI_SUBS_FETCH_PLANS_MWEB}&cc=${geoCurrentCountry}&listView=true`;
  //   makeRequest.get(planUrl).then(res => {
  //     if (res?.data?.data) {
  //       console.log('response is', res);
  //       setSubscription(res.data.data);
  //     }
  //   });
  // }, []);
  // useEffect(
  //   () => {
  //     if (geoCurrentCountry) {
  //       loadTOIPlusNudgeData(true, geoCurrentCountry);
  //     }
  //   },
  //   [geoCurrentCountry],
  // );

  // const handleOfferClick = selectedPlan => {
  //   const offer = true;
  //   const justPayRedirect = false;
  //   handlePlanClick(
  //     null,
  //     translationData,
  //     userData,
  //     true,
  //     geoCurrentCountry,
  //     selectedPlan,
  //     {
  //       selectedPlan,
  //       inGracePeriod,
  //       ispreExpired,
  //       userType,
  //       daysRemaining,
  //       offer,
  //       justPayRedirect,
  //     },
  //   );
  // };
  const onWidgetClick = (EA, CD) => {
    gaWrapper(
      'send',
      'event',
      `WAP-${geoCurrentCountry || 'IN'}-NHP1`,
      EA,
      `Ps-${prcStatus}`,
      {
        nonInteraction: 0,
      },
    );
    if (CD) {
      fireCustomDimension(CD, 'dimension31');
    }
  };

  if (!item.items || !item.items.length) {
    return null;
  }

  // For christmas sale
  useEffect(() => {
    const geoCountry = getGeoCountry();
    const endDate =
      geoCountry === 'IN'
        ? new Date('Dec 26, 2021 23:59:00').getTime()
        : new Date('Dec 31, 2021 23:59:00').getTime();
    const startDate = new Date('Dec 22, 2021 23:00:00').getTime();
    const todayDate = Date.now();
    const passedTime = todayDate - startDate;
    const remainingTime = endDate - todayDate;
    if (passedTime >= 0 && remainingTime >= 0) {
      setisSaleLive(true);
    } else {
      setisSaleLive(false);
    }
  }, []);
  // end here

  useEffect(
    () => {
      if (userPrcData) {
        getPreExpiryFormattedTime(userPrcData).then(res => {
          setDaysRemaining(res);
        });
        getGraceFormattedTime(userPrcData).then(res => {
          setGraceDate(res);
        });
        checkGracePeriod(userPrcData).then(res => {
          setInGracePeriod(res);
        });
        checkPreExpireDate(userPrcData).then(res => {
          setIsPreExpired(res);
        });
        checkNewUser(userPrcData).then(res => {
          setUserType(res);
        });
      }
    },
    [userPrcData],
  );

  const getTopSection = () => {
    const { TOIHPWidget } = translationData;
    if (inGracePeriod) {
      const { grace } = TOIHPWidget;
      const gracePeriodHeading = grace?.h2.replace(
        '<gracedate>',
        `${graceDate}`,
      );
      return (
        <h2
          className={s.renewalHeading}
          dangerouslySetInnerHTML={{
            __html: gracePeriodHeading,
          }}
        />
      );
    } else if (ispreExpired) {
      const oneDayRemaining = checkIfOneDayRemaining(daysRemaining);
      const days = !oneDayRemaining ? `${daysRemaining} days` : 'Today';
      const { preExpiry } = TOIHPWidget;
      const daysHtml = preExpiry?.h1?.replace(
        `<span class='expriedaysremaining'><remainingDays></span>`,
        `${
          !oneDayRemaining ? 'in' : ''
        } <span class=expriedaysremaining>${days}</span>`,
      );
      return (
        <>
          <h2
            className={s.renewalHeading}
            dangerouslySetInnerHTML={{
              __html: daysHtml,
            }}
          />
          <p
            className={s.renewalDesc}
            dangerouslySetInnerHTML={{
              __html: preExpiry?.h2,
            }}
          />
        </>
      );
    }
    return (
      <h2 className={s.heading}>
        <span
          className={s.widgetLabelsHeading}
          dangerouslySetInnerHTML={{
            __html: widgetLabels.h1,
          }}
        />
      </h2>
    );
  };

  const getButtonText = () => {
    const { TOIHPWidget } = translationData;
    if (inGracePeriod) {
      const { grace } = TOIHPWidget;
      return grace?.ctaTxt;
    } else if (ispreExpired) {
      const { preExpiry } = TOIHPWidget;
      return preExpiry?.ctaTxt;
    }
    return widgetLabels.ctaTxt;
  };

  // const experimentedValue =
  //   typeof window !== 'undefined' &&
  //   typeof window.abJustPayExperiment !== 'undefined' &&
  //   window.abJustPayExperiment;

  // const experimentJustpay = () => {
  //   if (experimentedValue === '1') {
  //     return true;
  //   }
  //   return false;
  // };
  // const showOffer = experimentBasedValue();
  // const redirectionExp = experimentJustpay();

  const handleSubscriptionClick = () => {
    setPayloadInfo(
      `TOIPlus_InlineWidgets|CTA-${getButtonText()}-click`,
      'NON_STORY',
    );
    onWidgetClick(`TOIPlus_InlineWidgets|CTA-${getButtonText()}-click`);
    // if (redirectionExp) {
    // const offer = false;
    // const justPayRedirect = true;
    // const pageType = 'home';
    // let selectedPlan;
    // if (
    //   subscriptionRes &&
    //   Array.isArray(subscriptionRes.plans) &&
    //   subscriptionRes.plans.length > 0
    // ) {
    //   for (let i = 0; i < subscriptionRes.plans.length; i += 1) {
    //     if (
    //       subscriptionRes.plans[i] &&
    //       subscriptionRes.plans[i].durationInDays &&
    //       subscriptionRes.plans[i].durationInDays === YEAR_IN_DAYS &&
    //       subscriptionRes.plans[i].planType &&
    //       subscriptionRes.plans[i].planType === PAID &&
    //       subscriptionRes.plans[i].subscription &&
    //       subscriptionRes.plans[i].subscription.accessType &&
    //       subscriptionRes.plans[i].subscription.accessType === TOI_PLUS
    //     ) {
    //       selectedPlan = subscriptionRes.plans[i].planId;
    //     }
    //   }
    // }
    // handlePlanClick(
    //   null,
    //   translationData,
    //   userData,
    //   true,
    //   geoCurrentCountry,
    //   selectedPlan,
    //   {
    //     selectedPlan,
    //     inGracePeriod,
    //     ispreExpired,
    //     userType,
    //     daysRemaining,
    //     offer,
    //     justPayRedirect,
    //     pageType,
    //   },
    // );
    // }
    // else
    if (Cookie.get('ssoid') || Cookie.get('ssoId')) {
      getEncTicket(true).then(data => {
        window.location.href = redirectToNewPlanpage(
          newPlanpageMetaData(translationData, data),
        );
      });
    } else {
      window.location.href = redirectToNewPlanpage(
        newPlanpageMetaData(translationData, {}),
      );
    }
  };

  return (
    widgetLabels && (
      <ElementInView
        gaCategory={WAP_INLINE_TOIPLUS_GA_CAT}
        gaAction="TOIPlus_InlineWidgets|View"
        gaLabel={`Ps-${
          !userData?.isLoggedIn && prcStatus === 0 ? -1 : prcStatus
        }`}
        className={`${s.toiplus_widget} ${isSaleLive ? s.sale_widget : ''}`}
      >
        <div className={s.plusLogo} />
        {getTopSection()}
        {/* <h2 className={s.heading}>{widgetLabels.h1}</h2> */}
        <h4 className={s.tagLine}>Today&apos;s top exclusives</h4>
        <div className={s.stories}>
          {item.items.slice(0, 10).map((news, index) => (
            <Card
              data={{
                ...news,
                wu:
                  news &&
                  news.wu &&
                  news.wu.replace(
                    'https://timesofindia.indiatimes.com',
                    'https://m.timesofindia.com',
                  ),
              }}
              isVerticalTile
              isIconNeeded={
                translationData.PPSPriceWidget &&
                msid.indexOf(news.id) === -1 &&
                true
              }
              isPaperStoryText={
                prcStatus !== 5 &&
                prcStatus !== 1 &&
                msid.indexOf(news.id) === -1
              }
              payPerTxt={
                translationData.PPSPriceWidget &&
                translationData.PPSPriceWidget['0'].h1
              }
              itemClass={s.news_card}
              onClick={() =>
                onWidgetClick(
                  `TOIPlus_InlineWidgets|storyno-${index + 1}_${news.hl}`,
                  news.id,
                )
              }
              imgWidth="140"
            />
          ))}
          <div className={s.readMore}>
            <InViewObserver
              ga={{
                category: WAP_INLINE_TOIPLUS_GA_CAT,
                action: 'TOIPlus_InlineWidgets|Swipe',
                label: `Ps-${prcStatus}`,
              }}
            >
              <Link
                to={item.path}
                onClick={() =>
                  onWidgetClick(`TOIPlus_InlineWidgets|Morestories`)
                }
              >
                More stories
              </Link>
            </InViewObserver>
          </div>
        </div>
        {(!isUserPrime || inGracePeriod) && (
          <div
            className={s.button}
            dangerouslySetInnerHTML={{
              __html: getButtonText() || 'Subscribe Now',
            }}
            onClick={() => {
              handleSubscriptionClick(widgetLabels?.ctaLink);
            }}
          />
        )}
        {/* <div>
          {homePageOffers &&
            !isUserPrime && (
              <Offers
                isWapView
                pageType="home"
                homePageOffers={homePageOffers}
                handleOfferClick={handleOfferClick}
                subscriptionRes={subscriptionRes}
                userData={userData}
              />
            )}
        </div> */}
      </ElementInView>
    )
  );
}

TOIPlusWidgetMobile.propTypes = {
  item: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        hl: PropTypes.string,
        image: PropTypes.shape({}),
        du: PropTypes.string,
        imageid: PropTypes.string,
        wu: PropTypes.string,
      }),
    ),
    path: PropTypes.string,
  }).isRequired,
  translationData: PropTypes.shape({
    TOIHPWidget: PropTypes.shape({}),
  }).isRequired,
  isUserPrime: PropTypes.bool,
  geoCurrentCountry: PropTypes.string,
};

TOIPlusWidgetMobile.defaultProps = {
  isUserPrime: false,
  geoCurrentCountry: '',
};
// const mapDispatchToProps = dispatch => ({
//   loadTOIPlusNudgeData: (isMobile, countryCode) => {
//     dispatch(loadNudgeData(isMobile, countryCode));
//   },
// });

const mapStateToProps = state => ({
  translationData: _get(state, 'translationConfig.data', {}),
  geoCurrentCountry: state.geo?.currentCountry,
  // homePageOffers: _get(
  //   state?.translationConfig?.nudges,
  //   'toidomain.Home.Offers',
  //   null,
  // ),
  userData: _get(state, 'login.userData', {}),
  userPrcData: state.login.userPrcData,
});

export default connect(mapStateToProps, null)(TOIPlusWidgetMobile);
